import { ApiResult, request, safeRequest } from '@synergy/api';

import { SupplierSpecialOffer } from '../../models/supplier-special-offer';
import { SupplierSpecialOffersDetailOverviewApi } from '../overview/api/supplier-special-offers-detail-overview-api';
import { SupplierSpecialOffersDetailProductsApi } from '../products/api/supplier-special-offers-detail-products-api';

export class SupplierSpecialOffersDetailApi {
    constructor(protected baseUrl: string) {
        this.Overview = new SupplierSpecialOffersDetailOverviewApi(this.baseUrl);
        this.Products = new SupplierSpecialOffersDetailProductsApi(this.baseUrl);
    }

    public Overview: SupplierSpecialOffersDetailOverviewApi;
    public Products: SupplierSpecialOffersDetailProductsApi;

    public deleteSupplierSpecialOffer(id: number): Promise<ApiResult<SupplierSpecialOffer>> {
        return safeRequest(
            () => request.delete(`${this.baseUrl}/supplier-special-offers/${id}`),
            response => response.data
        );
    }
}
